module.exports = __webpack_public_path__ + "static/media/signup-background.ab97e774.jpeg";